import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { returnUpDownClassname } from "utils/helpers";

const StabilityCard = (props) => {
  const { metrics } = props.optionsResults;
  const { firstHalfSuccessRate, secondHalfSuccessRate, delta } =
    metrics.stability;

  return (
    <GenericCard
      title="Stability over time"
      tooltipText="Success rate split chronologically into two halves. A large delta means the signal's edge is regime-dependent -- it backtested well but isn't necessarily reliable going forward."
    >
      <div className="flex gap-8">
        <div>
          <h5>First half</h5>
          <h3>{firstHalfSuccessRate}%</h3>
        </div>
        <div>
          <h5>Second half</h5>
          <h3>{secondHalfSuccessRate}%</h3>
        </div>
        <div>
          <h5>Delta</h5>
          <h3 className={returnUpDownClassname(-Math.abs(delta))}>{delta}%</h3>
        </div>
      </div>
    </GenericCard>
  );
};

StabilityCard.propTypes = { optionsResults: PropTypes.object };

export default StabilityCard;
